import {
  WarningCircleIcon,
  QuestionIcon,
  PackageIcon,
  ArrowCounterClockwiseIcon,
  RowsIcon,
  LineSegmentIcon,
} from '@phosphor-icons/react';

export const ErrorIcon = WarningCircleIcon;
export const Product = PackageIcon;
export const ProductOutOfStock = PackageIcon;
export const Unknown = QuestionIcon;
export const Reset = ArrowCounterClockwiseIcon;
export const WorkflowSteps = RowsIcon;
export const WorkflowEdges = LineSegmentIcon;
